import { create } from "zustand"
import type { ActiveError } from "./types"

interface ErrorState {
  activeErrors: Map<string, ActiveError>
  addError: (error: ActiveError) => void
  removeError: (code: string) => void
  clearAll: () => void
  fatalError: () => ActiveError | undefined
  warnings: () => ActiveError[]
  transientErrors: () => ActiveError[]
}

export const useErrorStore = create<ErrorState>((set, get) => ({
  activeErrors: new Map(),

  addError: (error) =>
    set((s) => {
      const next = new Map(s.activeErrors)
      next.set(error.code, error)
      return { activeErrors: next }
    }),

  removeError: (code) =>
    set((s) => {
      const next = new Map(s.activeErrors)
      next.delete(code)
      return { activeErrors: next }
    }),

  clearAll: () => set({ activeErrors: new Map() }),

  fatalError: () =>
    [...get().activeErrors.values()].find((e) => e.severity === "fatal"),

  warnings: () =>
    [...get().activeErrors.values()].filter((e) => e.severity === "warning"),

  transientErrors: () =>
    [...get().activeErrors.values()].filter((e) => e.severity === "transient"),
}))
